/**
 * @generated SignedSource<<89c36d6cde336b2c111d55a5921c4c96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUnauthenticated_company$data = {
  readonly features: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly " $fragmentType": "useUnauthenticated_company";
};
export type useUnauthenticated_company$key = {
  readonly " $data"?: useUnauthenticated_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUnauthenticated_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUnauthenticated_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "features",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "dfa93b979a33aad6734ec727b5e157f2";

export default node;
